export function toLowerCaseLanguages(languages: string[]): string[] {
  return languages.map(lang => lang.toLowerCase());
}

export function getBrowserLanguage(): string {
  return navigator.language.split('-')[0];
}
